import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import CostCenterListPage from './pages/CostCenterListPage';

export const costCenterModule: ModuleDefinition = {
  routes: [{ path: 'corporate/cost-center', element: <CostCenterListPage /> }],
  menuItems: [
    {
      label: 'Kurumsal: Masraf Merkezleri',
      path: 'corporate/cost-center',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
